import { DictionaryAutocomplete, useStaticListSource } from '@eas/common-web';
import { ExportTag } from '@enums';

export function useExportTags() {
  return useStaticListSource<DictionaryAutocomplete>([
    { id: ExportTag.WORK_ORDERS, name: 'Pracovné príkazy' },
  ]);
}
